module.exports = __webpack_public_path__ + "img/hochiminh.0f08ced0.jpg";